module.exports = __webpack_public_path__ + "img/checked.0699b359.png";